(() => {
  if (customElements.get('bca-product-share')) return;
  class ProductShare extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const status = this.querySelector('[data-share-status]');
      const field = this.querySelector('input');
      const native = this.querySelector('[data-share-native]');
      const url = this.dataset.url;
      const title = this.dataset.title;
      native.hidden = typeof navigator.share !== 'function';
      native.addEventListener('click', async () => {
        try {
          status.textContent = '';
          await navigator.share({ title, text: title + ' · Bacanime', url });
        } catch (error) {
          if (error.name !== 'AbortError') status.textContent = 'Puedes copiar el enlace o compartir por WhatsApp.';
        }
      });
      this.querySelector('[data-share-copy]').addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(url);
          status.textContent = 'Enlace copiado. Compártelo con tu dúo.';
        } catch (_) {
          field.focus();
          field.select();
          status.textContent = 'Selecciona y copia el enlace de arriba.';
        }
      });
    }
  }
  customElements.define('bca-product-share', ProductShare);
})();